import React from 'react';

const words = ['Online Marketing', 'Brand Strategy', 'Digital Advertising', 'Content', 'Performance Analytics', 'Growth'];

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-black bg-ink py-5 text-paper" aria-hidden="true">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center">
            {words.map((word, i) => (
              <span key={`${copy}-${i}`} className="flex items-center">
                <span className={`px-8 text-2xl tracking-[-0.03em] sm:text-3xl ${i % 2 ? 'font-serif italic text-amber' : 'font-light'}`}>
                  {word}
                </span>
                <span className="font-slab text-lg text-paper/40">Y</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
